/** Search result cap; fewer rows means a complete set, exactly this many may be truncated. */
export const ADMIN_USERS_SEARCH_LIMIT = 1000;

/** Shared filter values/labels so the header picker and the chip cannot drift. */
export const ADMIN_USER_STATUS_VALUES = ['active', 'pending', 'deleted'] as const;
export type AdminUserStatusValue = (typeof ADMIN_USER_STATUS_VALUES)[number];
export const ADMIN_USER_STATUS_LABELS: Record<AdminUserStatusValue, string> = {
  active: 'Active',
  pending: 'Pending',
  deleted: 'Deleted',
};
export const ADMIN_USER_STATUS_OPTIONS = ADMIN_USER_STATUS_VALUES.map((value) => ({
  value,
  label: ADMIN_USER_STATUS_LABELS[value],
}));

export const ADMIN_USER_ROLE_VALUES = ['student', 'teacher', 'org_admin', 'internal', 'superuser'] as const;
export type AdminUserRoleValue = (typeof ADMIN_USER_ROLE_VALUES)[number];
export const ADMIN_USER_ROLE_LABELS: Record<AdminUserRoleValue, string> = {
  student: 'Student',
  teacher: 'Teacher',
  org_admin: 'Org Admin',
  internal: 'Internal',
  superuser: 'Superuser',
};
export const ADMIN_USER_ROLE_OPTIONS = ADMIN_USER_ROLE_VALUES.map((value) => ({ value, label: ADMIN_USER_ROLE_LABELS[value] }));

export const ADMIN_USER_PLAN_VALUES = ['FREE', 'PLUS', 'PARTNER'] as const;
export type AdminUserPlanValue = (typeof ADMIN_USER_PLAN_VALUES)[number];
export const ADMIN_USER_PLAN_LABELS: Record<AdminUserPlanValue, string> = { FREE: 'Free', PLUS: 'Plus', PARTNER: 'Partner' };
export const ADMIN_USER_PLAN_OPTIONS = ADMIN_USER_PLAN_VALUES.map((value) => ({ value, label: ADMIN_USER_PLAN_LABELS[value] }));

// Only Site Admin is shown; other institution roles never match the UI.
export const ADMIN_USER_INSTITUTIONAL_ROLE_VALUES = ['site_admin'] as const;
export type AdminUserInstitutionalRoleValue = (typeof ADMIN_USER_INSTITUTIONAL_ROLE_VALUES)[number];
export const ADMIN_USER_INSTITUTIONAL_ROLE_LABELS: Record<AdminUserInstitutionalRoleValue, string> = { site_admin: 'Site Admin' };
export const ADMIN_USER_INSTITUTIONAL_ROLE_OPTIONS = ADMIN_USER_INSTITUTIONAL_ROLE_VALUES.map((value) => ({
  value,
  label: ADMIN_USER_INSTITUTIONAL_ROLE_LABELS[value],
}));
